export class AooDTO {
  codice: string;
  descrizione: string;
}
